export const HOME = {
  emergentLink: "emergent-link",
  navJoinMovementBtn: "nav-join-movement-btn",
  navLogo: "nav-logo",
  heroCtaBtn: "hero-cta-btn",
  heroSecondaryBtn: "hero-secondary-btn",
  finalApplyBtn: "final-apply-btn",
  finalPartnerBtn: "final-partner-btn",
  finalSponsorBtn: "final-sponsor-btn",
  mobileMenuToggle: "mobile-menu-toggle",
};
